'use client';

const UploadCompletionLiveRegion = ({ message }: { message: string | null }) => (
  <span aria-live="polite" className="sr-only">
    {message ?? ''}
  </span>
);

export { UploadCompletionLiveRegion };
